export const flattenFamilias = (familias, prefix = "") => {
    const result = [];
    for (const f of familias) {
        const label = prefix ? `${prefix} > ${f.nombre}` : f.nombre;
        result.push({ label, value: f.id || 0, activa: f.activa ?? true });
        if (Array.isArray(f.hijos) && f.hijos.length) {
            result.push(...flattenFamilias(f.hijos, label));
        }
    }
    return result;
};
